// @flow

import axios from 'axios';
import React from 'react';
import { IntlProvider, type IntlShape } from 'react-intl';
import { en_US, zh_HK } from '../locales'; // eslint-disable-line camelcase
import { getAllQueryParams } from '../helpers/queryparam';

type LocaleContextValue = {
  intl: IntlShape,
};

export const DEFAULT_LOCALE = 'zh-hk';

const messages = {
  'zh-hk': zh_HK,
  en: en_US,
};

export const LocaleContext: React$Context<LocaleContextValue> = React.createContext(
  {},
);

export const useLocaleContext = () => React.useContext(LocaleContext);

export const LocaleProvider = ({ children }: { children: React$Node }) => {
  const { lang } = getAllQueryParams();

  const locale = lang in messages ? lang : DEFAULT_LOCALE;

  axios.defaults.headers.common['Accept-Language'] = locale;
  localStorage.setItem('locale', locale);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};
